import "../../custom.css";
import BulkDeleteModal from '../../pages/HierachyManagementDashboard/BulkDeleteModal';

export default function BulkDeleteModalViewModel({ isOpen, cancel, checkedItems, data, updateTreePostDelete, makeToast, deselectAll }) {
    

    return (
        <BulkDeleteModal
            isOpen={isOpen}
            cancel={cancel}
            checkedItems={checkedItems}
            data={data}
            updateTreePostDelete={updateTreePostDelete}
            makeToast={makeToast}
            deselectAll={deselectAll}
        />
    )

};